import {Component} from '@angular/core';
import {Observable} from "rxjs";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../../../services/loader/loader.service";
import Helper from "../../../Helper/Helper";
import PermissionsHelper from "../../../Helper/PermissionsHelper";
import {Router} from "@angular/router";
import {Recruit} from "../../../Interfaces/Recruit.interface";

@Component({
  selector: 'app-recruits',
  templateUrl: './recruits.component.html'
})
export class RecruitsComponent {

  constructor(private httpClient: HttpClient, protected loader: LoaderService, public router: Router) {
    this.loader.showLoader()
    this.recruits = this.getRecruits()
  }

  public recruits: Observable<Recruit[]> | undefined
  public apierror: boolean = true


  private getRecruits(sortby: string = "", sorttype: string = ""): Observable<Recruit[]> {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    console.log(urlSearchParams.toString())

    return new Observable(subscriber => {

      this.httpClient.get<RestResponse<Recruit[]>>(RestHelper.API_BASE_URL + "recruit/getRecruitList?admin=true&" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
        next: (value) => {
          subscriber.next(value.data)
          this.loader.hideLoader()
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }

  public recreateindexsuccess: boolean | undefined

  public recreateIndex(uuid: string | undefined = undefined) {
    this.loader.showLoader()

    const urlSearchParams = new URLSearchParams()

    if(uuid !== undefined) {
      urlSearchParams.append("uuid", uuid)
    }

    urlSearchParams.append("table", "recruits")

    this.httpClient.get<any>(RestHelper.API_BASE_URL + "rebuildIndex?" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
      next: () => {

        this.loader.hideLoader()
        this.recreateindexsuccess = true
      }, error: (err) => {
        console.log(err)
        this.recreateindexsuccess = false
        this.loader.hideLoader()
      }
    })
  }

  public changePublishedStatus(event: Event, uuid: string) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("uuid", uuid)
    body.append("published", String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'recruit/updateRecruit', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.recruits = this.getRecruits(property, sorttype)
  }

  protected readonly Helper = Helper;
  protected readonly PermissionsHelper = PermissionsHelper;
}
